// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BankId, BankIdT, verifyBankId } from "../front-end/bank-id";
import { DevType } from "../front-end/dev-type";
import { LiftId, LiftIdT, verifyLiftId } from "../front-end/lift-id";
import { Message, MessageT, verifyMessage } from "../ln2/message";

export class Ln2MessageLookupData implements flatbuffers.IUnpackableObject<Ln2MessageLookupDataT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Ln2MessageLookupData {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsLn2MessageLookupData(
    bb: flatbuffers.ByteBuffer,
    obj?: Ln2MessageLookupData,
  ): Ln2MessageLookupData {
    return (obj || new Ln2MessageLookupData()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsLn2MessageLookupData(
    bb: flatbuffers.ByteBuffer,
    obj?: Ln2MessageLookupData,
  ): Ln2MessageLookupData {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Ln2MessageLookupData()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankId(obj?: BankId): BankId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new BankId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  liftId(obj?: LiftId): LiftId | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new LiftId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  devType(): DevType {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DevType.Escalator;
  }

  msg(obj?: Message): Message | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Message()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  activeHigh(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  static startLn2MessageLookupData(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankIdOffset, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, liftIdOffset, 0);
  }

  static addDevType(builder: flatbuffers.Builder, devType: DevType) {
    builder.addFieldInt8(2, devType, DevType.Escalator);
  }

  static addMsg(builder: flatbuffers.Builder, msgOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, msgOffset, 0);
  }

  static addActiveHigh(builder: flatbuffers.Builder, activeHigh: boolean) {
    builder.addFieldInt8(4, +activeHigh, +true);
  }

  static endLn2MessageLookupData(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // bank_id
    builder.requiredField(offset, 6); // lift_id
    builder.requiredField(offset, 10); // msg
    return offset;
  }

  unpack(): Ln2MessageLookupDataT {
    return new Ln2MessageLookupDataT(
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.liftId() !== null ? this.liftId()!.unpack() : null,
      this.devType(),
      this.msg() !== null ? this.msg()!.unpack() : null,
      this.activeHigh(),
    );
  }

  unpackTo(_o: Ln2MessageLookupDataT): void {
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    _o.devType = this.devType();
    _o.msg = this.msg() !== null ? this.msg()!.unpack() : null;
    _o.activeHigh = this.activeHigh();
  }

  unpackFields(...fields: string[]): Ln2MessageLookupDataT {
    const t = new Ln2MessageLookupDataT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    }
    if (fieldSet.has("dev_type")) {
      t.devType = this.devType();
    }
    if (fieldSet.has("msg")) {
      t.msg = this.msg() !== null ? this.msg()!.unpack() : null;
    }
    if (fieldSet.has("active_high")) {
      t.activeHigh = this.activeHigh();
    }
    return t;
  }
}

export class Ln2MessageLookupDataT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankId: BankIdT | null = null,
    public liftId: LiftIdT | null = null,
    public devType: DevType = DevType.Escalator,
    public msg: MessageT | null = null,
    public activeHigh: boolean = true,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.bankId === null || this.bankId === undefined) {
      throw new Error('Required field "bank_id" is not set');
    }
    if (this.liftId === null || this.liftId === undefined) {
      throw new Error('Required field "lift_id" is not set');
    }
    if (this.msg === null || this.msg === undefined) {
      throw new Error('Required field "msg" is not set');
    }
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const liftId = this.liftId !== null ? this.liftId!.pack(builder) : 0;
    const msg = this.msg !== null ? this.msg!.pack(builder) : 0;

    Ln2MessageLookupData.startLn2MessageLookupData(builder);
    Ln2MessageLookupData.addBankId(builder, bankId);
    Ln2MessageLookupData.addLiftId(builder, liftId);
    Ln2MessageLookupData.addDevType(builder, this.devType);
    Ln2MessageLookupData.addMsg(builder, msg);
    Ln2MessageLookupData.addActiveHigh(builder, this.activeHigh);

    return Ln2MessageLookupData.endLn2MessageLookupData(builder);
  }

  clone(): Ln2MessageLookupDataT {
    const obj = new Ln2MessageLookupDataT();
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.liftId = this.liftId !== null ? this.liftId!.clone() : null;
    obj.devType = this.devType;
    obj.msg = this.msg !== null ? this.msg!.clone() : null;
    obj.activeHigh = this.activeHigh;
    return obj;
  }

  equals(other: Ln2MessageLookupDataT): boolean {
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.liftId !== null && other.liftId !== null) {
      if (!this.liftId!.equals(other.liftId!)) return false;
    } else if (this.liftId !== other.liftId) return false;
    if (this.devType !== other.devType) return false;
    if (this.msg !== null && other.msg !== null) {
      if (!this.msg!.equals(other.msg!)) return false;
    } else if (this.msg !== other.msg) return false;
    if (this.activeHigh !== other.activeHigh) return false;
    return true;
  }
}

export function verifyLn2MessageLookupData(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyBankId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "bank_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyLiftId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "lift_id");
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "msg");
    verifier.checkScalarField(tablePos, 12, 1);
  } finally {
    verifier.popDepth();
  }
}
